import { Component, Input, OnChanges, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { Entity, EntityType } from 'src/app/models/entities.model';
import { EntityHelper } from '../../helpers/entity-helper';
import { GenericRelation } from 'src/app/models/relations.model';

// tslint:disable: no-output-on-prefix
// tslint:disable: variable-name

@Component({
  selector: 'gio-entity-card-basic',
  templateUrl: './entity-card-basic.component.html',
  styleUrls: ['./entity-card-basic.component.scss']
})
export class EntityCardBasicComponent implements OnChanges {

  @Input() entity: GenericRelation;
  @Input() imageSize = 32;
  @Input() rounded = false;
  @Input() showType = true;
  @Input() selectable = false;
  @Input() style = {};
  @Input() showDeleteButton = false;
  @Input() elevation: 'z1' | 'z2' | '...';
  @Input() nameType: 'name' | 'nickname' | 'nickname||name' | 'name&&nickname' | 'auto' = 'auto';
  @Input() showVerificationBadge = true;
  @Input() showSelfUserBadge = true;
  @Input() boxShadow = true;

  private autoNameType: 'name' | 'nickname' | 'nickname||name' | 'name&&nickname';


  @Output()
  onSelect: EventEmitter<Entity> = new EventEmitter();

  @Output()
  removed: EventEmitter<Entity> = new EventEmitter();
  radius = '0%';
  iSize;

  showName = true;
  showNickname = true;

  mouse_over = false;

  public _card_style = {};
  public _card_classes = '';
  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    this.radius = !!this.rounded ? '100%' : '0%';
    this.iSize = this.imageSize; // this.rounded ? this.imageSize : (parseInt(this.imageSize.toString()) + 32);
    this.defineClasses();
    this.defineNames();


    if (this.entity) {
      if (this.entity.source_name) {
        if (this.entity.source_name.notInArray<EntityType>(['athletes', 'contributors', 'referees'])) {
          this.showSelfUserBadge = false;
        }
      } else {
        this.showSelfUserBadge = false;
      }
    }



    if (changes.style) {
      this.updateStyle();
    }

    if (changes.boxShadow) {
      this.updateStyle();
    }
  }

  private defineNames() {

    switch (this.nameType) {
      case 'name': {
        this.showName = true;
        this.showNickname = false;
        break;
      }

      case 'name&&nickname': {
        this.showName = true;
        this.showNickname = true;
        break;
      }

      case 'nickname': {
        this.showName = true;
        this.showNickname = false;
        break;
      }

      case 'nickname||name': {
        this.showName = true;
        this.showNickname = false;
        break;
      }

      case 'auto': {
        if (['athletes', 'referees', 'contributors', 'users'].includes(this.entity.source_name)) {
          this.showName = true;
          this.showNickname = true;
          this.autoNameType = 'name&&nickname';
        } else {
          this.showName = true;
          this.showNickname = false;
          this.autoNameType = 'nickname||name';
        }
        break;

      }

    }
  }

  private defineClasses() {
    const r = [];
    if (this.elevation) {
      r.push('mat-elevation-' + this.elevation);
    }
    this._card_classes = r.join(' ');
  }

  updateStyle() {

    const style: { [index: string]: any } = Object.assign({}, this.style);
    if (this.mouse_over) {
      style.backgroundColor = '#6368ff78';
    }

    if (!this.boxShadow) {
      style.boxShadow = 'none';
    }
    this._card_style = style;
  }

  getImageStyle() {

    return {
      width: this.iSize + 'px',
      height: this.iSize + 'px',
      margin: '0 auto'
    };
  }

  getEntityType() {

    if (!this.entity || !this.entity.source_name) {
      return '?';
    }
    return EntityHelper.toName(this.entity.source_name);
  }

  cardMouseEvent($event) {
    if (this.selectable) {
      this.mouse_over = $event.type == 'mouseover';
      this.updateStyle();
    }

  }

  getEntityStatusClass() {
    if (this.entity.status == 'FIRED_REQUESTED' || this.entity.status == 'QUIT_REQUESTED' || this.entity.status == 'TRANSFER_OUT') {
      return 'ending';
    }

    if (this.entity.status == 'TRANSFER_IN' || this.entity.status == 'OPEN_TICKET') {
      return 'starting';
    }

    if (this.entity.status == 'PENDING') {
      return 'pending';
    }

    if (this.entity.status == 'CANCELED' || this.entity.status == 'ENDED' || this.entity.status == 'REJECTED') {
      return 'notstarted';
    }

    return '';
  }

  getName() {
    if (!this.entity) {
      return '?';
    }
    if (this.entity.source_name === 'users' && this.entity.preferences && !this.entity.preferences.profile_completed) {
      return 'PERFIL NÃO CADASTRADO!';
    }

    const nameType = this.nameType == 'auto' ? this.autoNameType : this.nameType;

    if (nameType == 'name') { return this.entity.name?.capitalize(); }
    if (nameType == 'nickname') { return this.entity.nickname; }
    if (nameType == 'nickname||name') {
      let name = this.entity.nickname;
      if (!name) { name = this.entity.name?.capitalize(); }
      return name;
    }
    if (nameType == 'name&&nickname') { return this.entity.name?.capitalize(); }

  }

  getNickname() {
    if (this.entity.nickname) {
      return this.entity.nickname;
    }
  }

  remove(entity: Entity, event: MouseEvent){
    event.stopPropagation();
    event.preventDefault();
    this.removed.emit(entity);
  }

}
